import * as React from "react";
import ConfigContext from "../../context/ConfigContext";
import { EngagementConfiguration } from "../../types";
import CustomLauncher from "./CustomLauncher";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface Props {
  onExpand: () => void;
}

class UnavailableLauncher extends React.Component<Props & ConfigExtension, {}> {
  public render() {
    const { config } = this.props;

    return (
      <div className="velaro-unavailable-launcher">
        <CustomLauncher
          height={config.UnavailableLauncherIconHeight}
          width={config.UnavailableLauncherIconWidth}
          text={config.UnavailableLauncherCustomText}
          textColor={config.UnavailableLauncherTextColor}
          textSize={config.UnavailableLauncherFontSize}
          backgroundColor={config.UnavailableLauncherBackgroundColor}
          imageUrl={config.UnavailableLauncherCustomImageUrl}
          onExpand={this.props.onExpand}
          availabilityClassName="unavailable"
        />
      </div>
    );
  }
}

export default (props: Props) => (
  <ConfigContext.Consumer>
    {config => <UnavailableLauncher config={config} {...props} />}
  </ConfigContext.Consumer>
);
